import { ReactNode } from 'react';

type IProps = {
  text: ReactNode;
};

export const CustomComponentText = ({ text }: IProps) => {
  return <div className={'mx-auto max-w-840 text-center'}>{text}</div>;
};
